import React from 'react';

/**
 * Small badge showing AI status on a conversation or sub-conversation.
 * Shows: "AI" (active), "Escalated" (needs human), "Human" (takeover active)
 */
function AiIndicator({ aiEnabled, aiTakeoverStatus, needsHumanAttention }) {
  if (!aiEnabled) return null;

  let label, bgColor, textColor;

  if (aiTakeoverStatus === 'human_takeover') {
    label = 'Human';
    bgColor = '#dbeafe';
    textColor = '#1e40af';
  } else if (aiTakeoverStatus === 'escalated' || needsHumanAttention) {
    label = 'Escalated';
    bgColor = '#fef3c7';
    textColor = '#92400e';
  } else {
    label = 'AI';
    bgColor = '#d1fae5';
    textColor = '#065f46';
  }

  return (
    <span style={{
      display: 'inline-flex',
      alignItems: 'center',
      padding: '2px 6px',
      borderRadius: '4px',
      fontSize: '10px',
      fontWeight: '600',
      letterSpacing: '0.03em',
      background: bgColor,
      color: textColor,
      lineHeight: '14px'
    }}>
      {label}
    </span>
  );
}

export default AiIndicator;
